import React from 'react'

const SvgAppleOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.03 2.22a.75.75 0 010 1.06c-.469.47-.81 1.453-.947 2.798-.132 1.3-.055 2.776.157 4.049a.75.75 0 11-1.48.246c-.23-1.383-.316-2.993-.17-4.447.144-1.41.523-2.848 1.38-3.706a.75.75 0 011.06 0z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.03 2.22a.75.75 0 010 1.06c-.469.47-.81 1.453-.947 2.798-.132 1.3-.055 2.776.157 4.049a.75.75 0 11-1.48.246c-.23-1.383-.316-2.993-.17-4.447.144-1.41.523-2.848 1.38-3.706a.75.75 0 011.06 0z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.4 9.625a.75.75 0 01-.274 1.024c-3.57 2.065-6.151.759-6.943-.158a.75.75 0 111.134-.981c.299.345 2.08 1.563 5.057-.16a.75.75 0 011.025.275z'
    />
    <path d='M14.599 4.047a3.138 3.138 0 00-1.002 1.08 16.312 16.312 0 00-.785 1.636c-.558 1.316.543 1.187 1.958.987.65-.201 1.94-.453 2.476-.738 2.644-1.412.532-5.054-2.647-2.965z' />
    <path d='M16.927 8.198c.224-.084.443-.172.655-.263a5.33 5.33 0 001.399-.856C20.833 8.361 22 10.345 22 12.94c0 3.77-2.484 7.675-6.177 9.082-1.147.436-2.228.14-2.752-.007a71.992 71.992 0 01-.41-.117c-.381-.11-.51-.146-.66-.146l-.023.001-.07.008a3.497 3.497 0 00-.25.046c-.149.032-.277.064-.433.102-.103.025-.216.054-.356.087a8.2 8.2 0 01-1.08.194c-.388.038-.931.05-1.5-.13C4.154 20.76 2 16.76 2 12.94c0-2.708 1.272-4.751 3.267-6.025 1.27-.81 2.785-1.284 4.378-1.507-.02.142-.035.281-.05.419-.053.53-.077 1.077-.077 1.625C6.315 8.006 4 9.736 4 12.938c0 3.151 1.766 6.231 4.889 7.214.485.152 1.156-.013 1.814-.175.461-.114.916-.226 1.297-.226.458 0 .906.131 1.343.26.616.18 1.208.354 1.768.14C17.984 19.058 20 15.928 20 12.939c0-2.308-1.202-3.85-3.073-4.74z' />
  </svg>
)

export default SvgAppleOutline
